import React from 'react';
import { connect } from 'react-redux';
import { routeToPage, setNavigationDialogConfig } from '../../redux/modules/pathInfo';
import WebsiteNavigatorWidget from 'nucleus-widgets/lib/WebsiteNavigator/WebsiteNavigatorWidget';
import ContainerlessImageWidget from './ContainerlessImageWidget';
import ContainerlessRegisterNowWidget from './ContainerlessRegisterNowWidget';
import LogoutButtonWidget from './LogoutButtonWidget';
import { getWebsiteDisabledPageIds, getWebsiteChildIds, getWebsiteNavigationGroups,
  getCurrentPageId, isPlannerRegistration } from '../../redux/modules/reducer';
import {
  isPostRegPage, isRegistrationPage
} from '../../redux/modules/selectors/pages';
import ImageClassNames from 'nucleus-widgets/lib/Image/Image.less';
import ImageContainerClassNames from './ContainerlessImage.less';
import withMappedWidgetConfig from 'nucleus-widgets/lib/withMappedWidgetConfig';
import { isLoggedIn } from '../../redux/modules/selectors/currentRegistrant';
import { getPostRegPageGroupPagesForInvitee } from '../../utils/confirmationUtil';

const ContainerlessImageClasses = {
  ...ImageClassNames,
  ...ImageContainerClassNames
};

function openNavigatorDialog(content, style) {
  return (dispatch) => {
    dispatch(setNavigationDialogConfig({
      isOpen: true,
      content,
      style
    }));
  };
}
function closeNavigatorDialog() {
  return (dispatch) => {
    dispatch(setNavigationDialogConfig({
      isOpen: false
    }));
  };
}

/**
* Data wrapper for the website navigator widget.
*/
export default withMappedWidgetConfig(connect((state, props) => {
  const { website, userSession: { isPlanner, isPreview }, event: { isArchived } } = state;
  const { pages } = website;
  const { config } = props;

  // Determine the page data for the widget to display.
  const disabledPageIds = getWebsiteDisabledPageIds(state);
  const navigationGroups = getWebsiteNavigationGroups(state);
  let pageData;

  if (isArchived && !isPlanner && !isPreview) {
    pageData = [];
  } else {
    pageData = getWebsiteChildIds(state)
      .filter(id => !disabledPageIds.includes(id))
      .map(id => {
        if (pages[id]) {
          return {
            ...pages[id],
            name: props.translate(pages[id].name)
          };
        }
        return {
          ...navigationGroups[id],
          name: props.translate(navigationGroups[id].name)
        };
      });
    pageData.forEach(item => {
      if (item.childIds) {
        // eslint-disable-next-line no-param-reassign
        item.childPages = item.childIds
          .filter(id => !disabledPageIds.includes(id))
          .map(id => {
            return {
              ...pages[id],
              name: props.translate(pages[id].name)
            };
          });
      }
    });
  }

  // Only show post reg page data if the user is registered.
  const loggedIn = isLoggedIn(state);
  if (loggedIn) {
    const postRegPageGroup = pageData.find(item => item.id === 'postRegPages');
    postRegPageGroup.childPages =
      getPostRegPageGroupPagesForInvitee(state, props.translate);
  }

  // Only populate left content if there is a logo defined.
  let leftContent;
  if (config.shared.logo && config.shared.logo.asset && config.shared.logo.asset.assetUri) {
    leftContent = (
      <ContainerlessImageWidget {...props}
        classes={ContainerlessImageClasses}
        config={config.shared.logo} />
    );
  }

  // Populate the right content.
  const currentPageId = getCurrentPageId(state);
  let rightContent;
  if (isArchived && !isPlanner && !isPreview) {
    rightContent = null;
  } else if (config.shared.registerButton.display && !loggedIn
      && !isRegistrationPage(state, currentPageId)
      && !isPostRegPage(state, currentPageId)) {
    // Display the register now widget if not on a post reg page.
    // TODO: apply already registered link settings.
    rightContent = (
      <ContainerlessRegisterNowWidget {...props}
        config={{
          text: config.shared.registerButton.text,
          link: {
            enabled: config.shared.registerButton.alreadyRegisteredLink.display,
            text: config.shared.registerButton.alreadyRegisteredLink.text
          }
        }} />
    );
  } else if (config.shared.logoutButton.display && loggedIn) {
    // Display the logout button if on a post reg page.
    rightContent = (
      <LogoutButtonWidget {...props}
        config={{ text: config.shared.logoutButton.text }} />
    );
  }

  return {
    selectedPage: {
      id: currentPageId,
      name: pages[currentPageId] && props.translate(pages[currentPageId].name)
    },
    pageData,
    leftContent,
    rightContent,
    isPlanner: isPlannerRegistration(state)
  };
}, {
  navigateToPage: routeToPage,
  openNavigatorDialog,
  closeNavigatorDialog
})(WebsiteNavigator));

function WebsiteNavigator(props) {
  const { isPlanner } = props;
  return (isPlanner) ? <div/> : <WebsiteNavigatorWidget {...props} />;
}



// WEBPACK FOOTER //
// ./src/widgets/WebsiteNavigator/WebsiteNavigatorWidget.js